module.exports = __webpack_public_path__ + "static/media/arrowUp.bd22e595.svg";